import {
  ComponentSingleStyleConfig,
  forwardRef,
  IconButton,
  Tooltip,
  useStyleConfig,
} from "@chakra-ui/react";
import React, { ReactElement, useContext } from "react";

import {
  ComponentStyleProps,
  componentStylePropsOf,
} from "../../../lib/styles/props/component-style-props";
import { TipDelayContext } from "../../../contexts/TipDelayContext";

export type IconButtonBaseProps = {
  icon: ReactElement;
  size: "sm" | "md" | "lg";
  tipMessage?: string;
  ariaLabel: string;

  onClick?: () => void;
} & ComponentStyleProps;

export const IconButtonBase = forwardRef<IconButtonBaseProps, "button">(
  (
    {
      icon,
      size,
      tipMessage,
      ariaLabel,

      onClick,

      sx,
      ...rest
    }: IconButtonBaseProps,
    ref,
  ) => {
    const styles = useStyleConfig("IconButtonBaseStyles", { size });

    const tipDelay = useContext(TipDelayContext);

    return (
      <Tooltip label={tipMessage} openDelay={tipDelay.sm}>
        <IconButton
          aria-label={ariaLabel}
          variant="ghost"
          size={size}
          isRound={true}
          icon={icon}
          onClick={onClick}
          sx={{ ...styles, ...sx }}
          {...rest}
          ref={ref}
        />
      </Tooltip>
    );
  },
);

export const IconButtonBaseStyles: ComponentSingleStyleConfig = {
  baseStyle: {
    color: "gray.400",

    _hover: {
      bgColor: "gray.100",
      color: "gray.600",
    },
  },
  sizes: {
    sm: {
      minW: "24px",
      w: "24px",
      h: "24px",

      fontSize: "sm",
    },
    md: {
      minW: "32px",
      w: "32px",
      h: "32px",

      fontSize: "md",
    },
    lg: {
      minW: "40px",
      w: "40px",
      h: "40px",

      fontSize: "lg",
    },
  },
};
